var map = {
	"./de.svg": "./src/common/assets/icons/flags/de.svg",
	"./en.svg": "./src/common/assets/icons/flags/en.svg",
	"./es.svg": "./src/common/assets/icons/flags/es.svg",
	"./fr.svg": "./src/common/assets/icons/flags/fr.svg",
	"./it.svg": "./src/common/assets/icons/flags/it.svg",
	"./ja.svg": "./src/common/assets/icons/flags/ja.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/common/assets/icons/flags sync recursive ^\\.\\/.*\\.svg$";